import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana96Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1462_13002)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M622.893 649.777L608.87 620.563L567.971 640.429L584.331 674.317C593.679 670.033 613.545 660.996 618.219 659.126C622.893 657.256 623.283 652.115 622.893 649.777Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M551.61 690.676L584.33 674.316L567.97 640.428L525.902 660.293C528.628 665.747 534.783 678.289 537.587 684.833C540.392 691.377 548.104 691.455 551.61 690.676Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M592.508 586.673L608.868 620.561L567.968 640.427L551.608 606.538L592.508 586.673Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M509.544 626.407L525.904 660.295L567.972 640.429L551.612 606.541L509.544 626.407Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M493.182 591.353L509.541 626.41L551.61 606.544L535.25 571.487L493.182 591.353Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M577.318 552.785L536.418 572.651L551.609 606.539L592.509 586.673L577.318 552.785Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M560.96 518.898L577.319 552.787L536.42 572.652L520.06 538.764L560.96 518.898Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M477.987 557.46L493.178 591.348L535.246 571.482L520.055 538.763L477.987 557.46Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M461.633 522.405L477.993 557.461L520.061 538.764L502.533 502.539L461.633 522.405Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M544.602 485.011L560.961 518.899L520.062 538.764L503.702 504.876L544.602 485.011Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M528.239 451.123L544.599 485.011L503.699 504.877L487.339 472.157L528.239 451.123Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M445.271 488.516L461.631 522.404L502.53 502.539L485.002 468.65L445.271 488.516Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M428.912 453.46L445.272 488.517L485.003 468.652L469.812 433.595L428.912 453.46Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M511.876 417.236L472.145 437.102V438.27L487.336 472.159L528.236 451.125L511.876 417.236Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M495.518 383.346L511.878 417.234L470.978 437.099L455.787 403.211L495.518 383.346Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M412.551 418.401L428.911 453.458L469.81 433.592L453.45 399.704L412.551 418.401Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M396.193 384.514L412.552 418.402L453.452 399.705L437.092 364.648L396.193 384.514Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M480.329 349.456L439.429 369.322L455.789 403.21L495.52 383.344L480.329 349.456Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M463.97 315.568L480.33 349.457L439.431 369.322L423.071 335.434L463.97 315.568Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M379.83 350.626L396.19 384.514L437.09 364.649L420.73 330.761L379.83 350.626Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M447.607 281.681L463.967 315.569L423.067 335.434L407.876 301.546L447.607 281.681Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M363.472 315.569L379.832 350.625L420.732 330.76L404.372 295.703L363.472 315.569Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M433.588 250.131L447.611 281.682L407.88 301.547L389.183 262.984C395.026 259.868 408.815 252.468 417.229 247.794C425.642 243.119 431.641 247.404 433.588 250.131Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M355.294 278.175L389.182 262.983L404.372 295.703L363.472 315.569C360.746 310.115 354.592 297.573 351.788 291.029C348.983 284.485 352.956 279.733 355.294 278.175Z" fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1462_13002" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1462_13002" transform="matrix(0.00160287 0 0 0.00212498 -3.24053 -1.67903)"/>
    </pattern>
    <image id="image0_1462_13002" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};